import type { AppointmentWithDetails } from "@/hooks/useAppointments";

export type AppointmentSummaryItem = {
  id: string;
  title: string;
  qty: number;
  kind: "item" | "package";
};

type TranslateFn = (key: string) => string;

export const buildAppointmentSummaryItems = (
  appointment: Pick<AppointmentWithDetails, "appointment_items" | "appointment_patient_packages">,
  t: TranslateFn,
): AppointmentSummaryItem[] => [
  ...(appointment.appointment_items ?? []).map((item) => ({
    id: item.id,
    title: item.title_snapshot || item.item?.name || t("appointmentForm.productsAndServicesShort"),
    qty: Math.max(1, Number(item.qty ?? 1)),
    kind: "item" as const,
  })),
  ...(appointment.appointment_patient_packages ?? []).map((pkg) => ({
    id: pkg.id,
    title:
      pkg.patient_package?.catalog_package?.item?.name ||
      pkg.catalog_package?.item?.name ||
      t("packages.packageLabel"),
    qty: 1,
    kind: "package" as const,
  })),
];
